import SectionHeading from "@/components/base/SectionHeading";
import { castList } from "@/mocks/movie";

export default function Cast() {
  return (
    <section id="cast" className="w-full bg-secondary-50 border-y border-secondary-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="grid lg:grid-cols-[0.8fr_1.2fr] gap-10 lg:gap-16 items-start">
          <div className="lg:sticky lg:top-28">
            <SectionHeading
              align="left"
              eyebrow="Cast & Crew"
              title="主创阵容"
              description="一部克制风格的作品，离不开台前幕后一以贯之的默契。"
            />
            <div className="mt-8 flex items-center gap-4 rounded-lg border border-secondary-200 bg-background-50 p-4">
              <span className="w-12 h-12 rounded-md bg-secondary-500 text-background-50 flex items-center justify-center">
                <i className="ri-team-line text-2xl"></i>
              </span>
              <p className="text-sm text-foreground-700 leading-relaxed">
                全片共 <strong className="text-foreground-950">7 位</strong> 核心主创参与，
                演员多为舞台剧出身，这也是影片对白节奏扎实的原因之一。
              </p>
            </div>
          </div>

          <ul className="divide-y divide-secondary-200 rounded-lg border border-secondary-200 bg-background-50 overflow-hidden">
            {castList.map((item) => (
              <li
                key={`${item.role}-${item.actor}`}
                className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-6 px-5 md:px-6 py-4 hover:bg-secondary-50 transition-colors"
              >
                <div className="sm:w-32 shrink-0">
                  <p className="text-xs text-foreground-500">角色 / 职务</p>
                  <p className="font-heading text-base font-bold text-foreground-950">{item.role}</p>
                </div>
                <div className="sm:w-28 shrink-0">
                  <p className="text-xs text-foreground-500">姓名</p>
                  <p className="text-sm font-semibold text-primary-700">{item.actor}</p>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.note}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}